<script>
    import { onMount } from 'svelte';
    import { screen, feedbackType } from './stores';
    import Logo from './common/Logo.svelte';
    import Space from './common/Space.svelte';
    const faceAnimation = [
        { transform: 'scale(1)'},
        { transform: 'scale(1.1)'},
        { transform: 'scale(1)'},
    ];

    const faceTiming = {
        duration: 3000,
        iterations: "Infinity"
    }

    onMount(async () => {
        document.getElementById("positive").animate(
            faceAnimation,
            faceTiming
        );
        
        document.getElementById("negative").animate(
            faceAnimation,
            faceTiming
        );
    });

</script>

<Logo />
<h1 class="more-detail">How was your experience?</h1>
<div class="faces-container">
    <div id="positive" class="positive" on:click={() => {$feedbackType = "Positive"; $screen=1}}><i class="far fa-smile"></i></div>
    <div id="negative" class="negative" on:click={() => {$feedbackType = "Negative"; $screen=1}}><i class="far fa-frown"></i></div>
</div>
<Space />

<style>

</style>